import { render, staticRenderFns } from "./AddAnalysis.vue?vue&type=template&id=49fdc665&"
import script from "./AddAnalysis.vue?vue&type=script&lang=ts&"
export * from "./AddAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports